/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionsBoardReferral } from './AdmissionsBoardReferral';
import {
    AdmissionsBoardReferralFromJSON,
    AdmissionsBoardReferralFromJSONTyped,
    AdmissionsBoardReferralToJSON,
    AdmissionsBoardReferralToJSONTyped,
} from './AdmissionsBoardReferral';
import type { AdmissionsBoardFacilityType } from './AdmissionsBoardFacilityType';
import {
    AdmissionsBoardFacilityTypeFromJSON,
    AdmissionsBoardFacilityTypeFromJSONTyped,
    AdmissionsBoardFacilityTypeToJSON,
    AdmissionsBoardFacilityTypeToJSONTyped,
} from './AdmissionsBoardFacilityType';
import type { AdmissionsBoardResponseUsersValue } from './AdmissionsBoardResponseUsersValue';
import {
    AdmissionsBoardResponseUsersValueFromJSON,
    AdmissionsBoardResponseUsersValueFromJSONTyped,
    AdmissionsBoardResponseUsersValueToJSON,
    AdmissionsBoardResponseUsersValueToJSONTyped,
} from './AdmissionsBoardResponseUsersValue';

/**
 * 
 * @export
 * @interface AdmissionsBoardResponse
 */
export interface AdmissionsBoardResponse {
    /**
     * Today in the facility's time zone, YYYY-MM-DD.
     */
    as_of_date: string;
    /**
     * 
     */
    facility_type: AdmissionsBoardFacilityType;
    /**
     * 
     */
    referrals: Array<AdmissionsBoardReferral>;
    /**
     * Every user referenced by a referral assignment, keyed by user_id.
     */
    users: { [key: string]: AdmissionsBoardResponseUsersValue; };
}



/**
 * Check if a given object implements the AdmissionsBoardResponse interface.
 */
export function instanceOfAdmissionsBoardResponse(value: object): value is AdmissionsBoardResponse {
    if (!('as_of_date' in value) || value['as_of_date'] === undefined) return false;
    if (!('facility_type' in value) || value['facility_type'] === undefined) return false;
    if (!('referrals' in value) || value['referrals'] === undefined) return false;
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function AdmissionsBoardResponseFromJSON(json: any): AdmissionsBoardResponse {
    return AdmissionsBoardResponseFromJSONTyped(json, false);
}

export function AdmissionsBoardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionsBoardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'as_of_date': json['as_of_date'],
        'facility_type': AdmissionsBoardFacilityTypeFromJSON(json['facility_type']),
        'referrals': ((json['referrals'] as Array<any>).map(AdmissionsBoardReferralFromJSON)),
        'users': (mapValues(json['users'], AdmissionsBoardResponseUsersValueFromJSON)),
    };
}

export function AdmissionsBoardResponseToJSON(json: any): AdmissionsBoardResponse {
    return AdmissionsBoardResponseToJSONTyped(json, false);
}

export function AdmissionsBoardResponseToJSONTyped(value?: AdmissionsBoardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_of_date': value['as_of_date'],
        'facility_type': AdmissionsBoardFacilityTypeToJSON(value['facility_type']),
        'referrals': ((value['referrals'] as Array<any>).map(AdmissionsBoardReferralToJSON)),
        'users': (mapValues(value['users'], AdmissionsBoardResponseUsersValueToJSON)),
    };
}

